import { useSelector, useDispatch } from "react-redux";
import { clearUser } from "../redux/slices/userSlice";
import { clearRestaurant } from "../redux/slices/restaurantsSlice";
import { stopAllControlling } from "../redux/slices/adminSlice";
import { postAttemptLogout } from "../services/authService";
import useLangNavigate from "./useLangNavigate";

export function useAuth() {
  const navigate = useLangNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const isAuthenticated = !!user.token;
  const userRoles = useSelector((state) => state.user.roles);

  const hasRole = (roles) => {
    return userRoles?.some((role) => roles.includes(role.label));
  };

  const isOffoodAdmin = hasRole(["admin"]);
  const isRestaurantAdmin = hasRole(["restaurantAdmin"]);
  const isCompanyAdmin = hasRole(["companyAdmin"]);
  const isBusinessDeveloper = hasRole(["businessDeveloper"]);
  const isPureRestaurantAdmin =
    isRestaurantAdmin && !isOffoodAdmin && !isCompanyAdmin;
  const belongsToRestaurant = hasRole([
    "restaurantAdmin",
    "restaurantEmployee",
  ]);
  const belongsToCompany = hasRole(["companyAdmin", "companyEmployee"]);

  const logout = () => {
    postAttemptLogout();
    localStorage.removeItem("token");
    dispatch(clearUser());
    dispatch(clearRestaurant());
    dispatch(stopAllControlling());
    navigate("/");
  };

  return {
    isAuthenticated,
    hasRole,
    isOffoodAdmin,
    isCompanyAdmin,
    isRestaurantAdmin,
    isPureRestaurantAdmin,
    isBusinessDeveloper,
    belongsToRestaurant,
    belongsToCompany,
    roles: userRoles,
    user,
    logout,
  };
}
